import React, { createContext, useContext, useState } from 'react';

interface IBrandProviderProps {
    children?: React.ReactNode;
    brand: IBrand;
}
interface IBrandContext {
    brand: IBrand;
}

const BrandContext = createContext<IBrandContext>({
    brand: {
        address: null,
        email: '',
        phone: '',
        analyticsGoogle: null,
        currencyCode: '',
        currencyMultiplier: 100,
        customDomain: null,
        galleryDomain: '',
        id: 0,
        isEligibleToManagePlan: true,
        isEmailVerified: false,
        labCatalogs: [],
        links: {},
        locale: '',
        name: '',
        subdomain: '',
        timeZone: '',
        useDefaultWatermark: false,
        website: null,
        type: 'brand'
    }
});

const BrandProvider: React.FC<IBrandProviderProps> = ({ brand, ...props }) => {
    const [storedBrand] = useState(brand);

    return <BrandContext.Provider value={{ brand: storedBrand }} {...props} />;
};

export const withBrand = <T extends object>(
    Component: React.ComponentType<T>
): React.FC<T & { brand: IBrand }> => {
    return function WithBrandComponent(props) {
        return (
            <BrandProvider brand={props.brand}>
                <Component {...props} />
            </BrandProvider>
        );
    };
};

export const useBrand = () => {
    const { brand } = useContext(BrandContext);

    return brand;
};
